module.exports = __webpack_public_path__ + "static/img/6.512b427f.jpg";